import { render, staticRenderFns } from "./Exchanges.vue?vue&type=template&id=2d4342ec&scoped=true&"
import script from "./Exchanges.vue?vue&type=script&lang=js&"
export * from "./Exchanges.vue?vue&type=script&lang=js&"
import style0 from "./Exchanges.vue?vue&type=style&index=0&id=2d4342ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4342ec",
  null
  
)

export default component.exports